import { useState } from "react";
import { css } from "../../../styled-system/css";
import { Flex } from "../../../styled-system/jsx";
import { useMutation } from "@tanstack/react-query";
import { apiClient } from "zodios/client";
import { TextField } from "components/fields/base/TextField";
import { Button } from "components/core/basic/Button";
import { successToast } from "utils/toasts";
import { Link } from "react-router-dom";
import { AuthLayout } from "layouts/AuthLayout";

function ForgetPassForm() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [emailSent, setEmailSent] = useState(false);

  const requestPasswordResetMutation = useMutation({
    mutationFn: async () => {
      await apiClient.requestPasswordReset({
        email: email.toLowerCase().trim(),
      });
    },
    onError: (error) => {
      if (typeof error.message === "string") {
        setError(error.message);
      } else {
        setError("Something went wrong sending password reset email.");
      }
    },
    onSuccess: () => {
      successToast({ message: "Reset password email successfully sent. Please check for inbox for next steps." });
      setEmailSent(true);
    },
  });

  return (
    <AuthLayout
      title={"Forgot your password?"}
      subtitle={"Enter your email and you'll receive instructions to reset your password."}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          requestPasswordResetMutation.mutate();
        }}
      >
        <Flex gap={"medium"} direction={"column"}>
          <TextField
            label={"Email"}
            type={"email"}
            onChange={(value) => {
              setEmail(value);
            }}
          />
        </Flex>
        <Button
          isPending={requestPasswordResetMutation.isPending}
          isDisabled={!email.trim().length}
          className={css({ width: "100%", marginTop: "large" })}
          type="submit"
        >
          Send Reset Password Link
        </Button>
      </form>
      <div className={css({ width: "100%", marginTop: "medium", textAlign: "center" })}>
        <Link to="/">Sign In Instead</Link>
      </div>
      {error && <p className={css({ paddingY: "large", textAlign: "center" })}>{error}</p>}
      {emailSent && (
        <p className={css({ paddingY: "large", fontSize: "small", textAlign: "center" })}>
          An email has been sent to the provided email address.
        </p>
      )}
    </AuthLayout>
  );
}

export default ForgetPassForm;
